import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { userApi, trainingApi } from '../../api'
import { TRAINING_SET_STATUS } from '../../constants'
import { useAuth } from '../../contexts/AuthContext'
import { useTheme } from '../../hooks/useTheme'
import { useTranslation } from '../../i18n'
import { EmptyState, Loading } from '../ui'

export default function ActiveTrainingSet() {
  const { user } = useAuth()
  const theme = useTheme()
  const { t } = useTranslation()
  const [setId, setSetId] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function resolveActiveSet() {
      if (!user?.id) {
        setLoading(false)
        return
      }
      try {
        const statistics = await userApi.getUserStatistics()
        const trainee = statistics.traineeStats
        let resolved = trainee?.closestTrainingSetId ?? null
        if (resolved == null && (trainee?.activeTrainingSets ?? 0) > 0) {
          const sets = await trainingApi.getAllTrainingSets()
          const active = sets.find(ts => ts.trainingSet.status === TRAINING_SET_STATUS.ACTIVE && !ts.isCurrentUserCoach)
          resolved = active?.trainingSet.id ?? null
        }
        if (!cancelled) setSetId(resolved)
      } catch {
        if (!cancelled) setSetId(null)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    void resolveActiveSet()
    return () => {
      cancelled = true
    }
  }, [user?.id])

  if (loading) {
    return <Loading message={t.common.loading} />
  }

  if (setId && user?.id) {
    return <Navigate to={`/trainee/${user.id}/set/${setId}`} replace />
  }

  return (
    <div className="p-5">
      <header className="mb-6">
        <h1 className="text-2xl font-bold mb-1" style={{ color: theme.text.primary }}>
          {t.quickAccess.items['active-training-set']}
        </h1>
      </header>
      <EmptyState
        icon="📋"
        title={t.activeTrainingSet.waitingTitle}
        message={t.activeTrainingSet.waitingBody}
      />
    </div>
  )
}
